/**
 * Chargement d'esptool-js (Espressif, Apache-2.0), servi tel quel depuis public/vendor/esptool-js :
 * le webpack 4 / Node 10 de l'extranet ne sait pas compiler cette bibliothèque moderne.
 * Le module est importé par un script de type module, puis exposé sur window.
 */

export const ESPTOOL_BASE = `${process.env.BASE_URL}vendor/esptool-js/`;
const ESPTOOL_URL = `${ESPTOOL_BASE}esptool-js-0.7.0.js`;
const GLOBAL_KEY = '__esptoolJs';
const LOAD_TIMEOUT = 15000;

let loading: Promise<any> | null = null;

export function loadEsptool(): Promise<any> {
  if (loading) {
    return loading;
  }

  loading = new Promise((resolve, reject) => {
    const win = window as any;
    if (win[GLOBAL_KEY]) {
      resolve(win[GLOBAL_KEY]);
      return;
    }

    const timer = window.setTimeout(() => {
      loading = null;
      reject(new Error("Impossible de charger esptool-js."));
    }, LOAD_TIMEOUT);

    window.addEventListener(GLOBAL_KEY, () => {
      window.clearTimeout(timer);
      resolve(win[GLOBAL_KEY]);
    }, {once: true});

    const script = document.createElement('script');
    script.type = 'module';
    script.textContent = `import * as esptool from '${ESPTOOL_URL}';
window.${GLOBAL_KEY} = esptool;
window.dispatchEvent(new Event('${GLOBAL_KEY}'));`;
    document.head.appendChild(script);
  });

  return loading;
}
